/* GANGWANI HOUSE · chrome face drawn on canvas, gliding red nav line, diamond glints */
(function () {
  /* where the diamond glints may land: points on the logo's own lines (0..1 of width, height) */
  var PTS = [[0.3,0.397],[0.562,0.895],[0.825,0.786],[0.388,0.233],[0.438,0.56],[0.412,0.918],[0.537,0.7],[0.925,0.949],[0.625,0.872],[0.125,0.132],[0.588,0.918],[0.338,0.023],[0.762,0.693],[0.863,0.42],[0.613,0.802],[0.388,0.389],[0.013,0.335],[0.938,0.693],[0.625,0.786],[0.537,0.802],[0.212,0.708],[0.412,0.591],[0.075,0.272],[0.963,0.381],[0.988,0.965],[0.375,0.272],[0.4,0.763],[0.475,0.584],[0.625,0.023],[0.55,0.125],[0.625,0.28],[0.825,0.887],[0.312,0.078],[0.113,0.467],[0.287,0.054],[0.35,0.436],[0.438,0.7],[0.812,0.895],[0.912,0.576],[0.412,0.63],[0.9,0.584],[0.688,0.864],[0.175,0.661],[0.362,0.241],[0.562,0.553],[0.037,0.179],[0.45,0.062],[0.65,0.241],[0.225,0.732],[0.925,0.358],[0.75,0.42],[0.175,0.646],[0.55,0.957],[0.512,0.623],[0.8,0.739],[0.775,0.576],[0.575,0.856],[0.9,0.529],[0.487,0.778],[0.65,0.879],[0.912,0.599],[0.613,0.879],[0.025,0.389],[0.4,0.514],[0.688,0.047],[0.7,0.444],[0.6,0.918],[0.825,0.28],[0.412,0.498],[0.675,0.786],[0.562,0.848],[0.762,0.84],[0.475,0.187],[0.925,0.35],[0.65,0.965],[0.438,0.856],[0.9,0.428],[0.463,0.451],[0.9,0.218],[0.325,0.125],[0.225,0.716],[0.425,0.716],[0.037,0.163],[0.525,0.521],[0.338,0.132],[0.512,0.607],[0.325,0.272],[0.65,0.031],[0.537,0.459],[0.45,0.63],[0.45,0.615],[0.613,0.21],[0.775,0.078],[0.562,0.918],[0.725,0.934],[0.125,0.086],[0.6,0.568],[0.787,0.879],[0.1,0.506],[0.675,0.444],[0.588,0.739],[0.625,0.389],[0.463,0.062],[0.5,0.475],[0.3,0.016],[0.8,0.14],[0.1,0.195],[0.45,0.911],[0.637,0.778],[0.3,0.054],[0.3,0.342],[0.95,0.599],[0.412,0.459],[0.575,0.926],[0.362,0.428],[0.912,0.272],[0.287,0.078],[0.887,0.514],[0.062,0.482],[0.55,0.545],[0.375,0.249],[0.487,0.568],[0.4,0.685],[0.812,0.755],[0.787,0.576],[0.412,0.903],[0.887,0.817],[0.037,0.187],[0.762,0.942],[0.787,0.739],[0.537,0.436],[0.938,0.63],[0.938,0.965],[0.087,0.397],[0.463,0.646],[0.762,0.42],[0.225,0.763],[0.55,0.467],[0.887,0.794],[0.6,0.514],[0.25,0.023],[0.412,0.872],[0.4,0.482],[0.475,0.568],[0.863,0.934],[0.7,0.887],[0.613,0.965],[0.062,0.241],[0.325,0.117],[0.675,0.965],[0.588,0.957],[0.45,0.506],[0.4,0.693],[0.388,0.537],[0.375,0.537],[0.963,0.918],[0.55,0.444],[0.4,0.724],[0.263,0.039],[0.713,0.887]];

  /* car wrap mirror chrome: bright sky on top, a soft horizon line, bright again below. No dark bands. */
  var CHROME = window.GW_CHROME = [[0, '#ffffff'], [.12, '#eaeff4'], [.26, '#c3cad2'], [.38, '#9ca5ae'], [.46, '#8c959f'], [.5, '#aab2bb'], [.55, '#f7f9fb'], [.62, '#ffffff'], [.74, '#ced4da'], [.86, '#a7afb8'], [1, '#e4e8ec']];

  /* draw the face as mirror chrome on a canvas: works even when the image comes from another domain */
  function chrome() {
    if (!window.GW_MASK) return;
    var targets = [].slice.call(document.querySelectorAll('.gw-mark'));
    var head = document.querySelector('.header__heading-link');
    if (head && !head.querySelector('.gw-head-chrome')) {
      var hc = document.createElement('canvas');
      hc.className = 'gw-head-chrome';
      hc.setAttribute('aria-hidden', 'true');
      head.appendChild(hc);
      targets.push(hc);
    } else if (head) {
      targets.push(head.querySelector('.gw-head-chrome'));
    }
    var canvases = targets.map(function (el) {
      if (el.tagName === 'CANVAS') return el;
      var c = el.querySelector('canvas');
      if (!c) { c = document.createElement('canvas'); el.appendChild(c); }
      return c;
    });
    var img = new Image();
    img.onerror = function () { document.body.classList.add('gw-nomask'); };
    img.onload = function () {
      document.body.classList.add('gw-chrome-ready');
      var t0 = performance.now();
      function frame(now) {
        if (!document.hidden) canvases.forEach(function (c) { paint(c, img, now - t0); });
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    };
    img.src = window.GW_MASK;
  }

  function paint(c, img, t) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    /* layout size, not on screen size, so a spinning logo keeps its shape */
    var r = { width: c.offsetWidth || c.clientWidth, height: c.offsetHeight || c.clientHeight };
    if (!r.width || !r.height) return;
    var W = Math.round(r.width * dpr), H = Math.round(r.height * dpr);
    if (c.width !== W || c.height !== H) { c.width = W; c.height = H; }
    var x = c.getContext('2d');
    x.globalCompositeOperation = 'source-over';
    x.clearRect(0, 0, W, H);
    /* fit the logo inside the box */
    var s = Math.min(W / img.naturalWidth, H / img.naturalHeight);
    var dw = img.naturalWidth * s, dh = img.naturalHeight * s;
    var ox = (W - dw) / 2, oy = (H - dh) / 2;
    x.drawImage(img, ox, oy, dw, dh);
    /* keep only the logo's shape, fill it with chrome */
    x.globalCompositeOperation = 'source-in';
    var g = x.createLinearGradient(0, oy, 0, oy + dh);
    CHROME.forEach(function (s) { g.addColorStop(s[0], s[1]); });
    x.fillStyle = g;
    x.fillRect(0, 0, W, H);
    /* the moving reflection: sweeps across, then rests, every 6.5 seconds */
    var p = (t % 6500) / 6500;
    if (p < 0.6) {
      var e = p / 0.6; e = e < .5 ? 2 * e * e : 1 - Math.pow(-2 * e + 2, 2) / 2;
      var cx = ox - dw * 0.4 + (dw * 1.8) * e;
      var bw = dw * 0.22;
      x.globalCompositeOperation = 'source-atop';
      var b = x.createLinearGradient(cx - bw, oy, cx + bw, oy + bw * 0.35);
      b.addColorStop(0, 'rgba(255,255,255,0)');
      b.addColorStop(0.5, 'rgba(255,255,255,1)');
      b.addColorStop(1, 'rgba(255,255,255,0)');
      x.fillStyle = b;
      x.fillRect(0, 0, W, H);
    }
    x.globalCompositeOperation = 'source-over';
  }

  function navBar() {
    var list = document.querySelector('.header__inline-menu .list-menu--inline');
    if (!list || list.querySelector('.gw-bar')) return;
    var bar = document.createElement('span');
    bar.className = 'gw-bar';
    list.appendChild(bar);
    var items = [].slice.call(list.querySelectorAll('.header__menu-item'));
    var active = list.querySelector('.header__active-menu-item');
    var activeLink = active ? active.closest('.header__menu-item') : null;
    function place(el) {
      if (!el) { bar.style.opacity = '0'; return; }
      var lr = list.getBoundingClientRect();
      var span = el.querySelector('span') || el;
      var r = span.getBoundingClientRect();
      bar.style.opacity = '1';
      bar.style.left = (r.left - lr.left) + 'px';
      bar.style.width = r.width + 'px';
    }
    items.forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        items.forEach(function (o) { o.classList.remove('gw-on'); });
        a.classList.add('gw-on');
        place(a);
      });
    });
    list.addEventListener('mouseleave', function () {
      items.forEach(function (o) { o.classList.remove('gw-on'); });
      place(activeLink);
    });
    place(activeLink);
    window.addEventListener('resize', function () { place(activeLink); });
    setTimeout(function () { place(activeLink); }, 400);
  }

  function glints() {
    var boxes = [].slice.call(document.querySelectorAll('[data-gw-glints]'));
    if (!boxes.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    function spawn(box) {
      var p = PTS[Math.floor(Math.random() * PTS.length)];
      var g = document.createElement('span');
      g.className = 'gw-glint';
      g.style.left = (p[0] * 100) + '%';
      g.style.top = (p[1] * 100) + '%';
      var big = Math.random() < .35;
      var r = big ? (54 + Math.random() * 26) : (24 + Math.random() * 16);
      var dur = big ? 1100 : 700 + Math.random() * 300;
      g.innerHTML = '<i class="v"></i><i class="h"></i><i class="core"></i>';
      [].forEach.call(g.querySelectorAll('i'), function (n) {
        n.style.setProperty('--r', r + 'px');
        n.style.setProperty('--d', dur + 'ms');
      });
      box.appendChild(g);
      setTimeout(function () { g.remove(); }, dur + 50);
    }
    function tick(box) {
      if (!document.hidden) {
        spawn(box);
        if (Math.random() < .3) setTimeout(function () { spawn(box); }, 120);
      }
      setTimeout(function () { tick(box); }, 500 + Math.random() * 900);
    }
    boxes.forEach(function (b) { if (!b.dataset.gwOn) { b.dataset.gwOn = '1'; tick(b); } });
  }

  function init() { chrome(); navBar(); glints(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
